import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const LockIcon = ({ title = 'Lock', ...props }: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox="0 0 24 24" {...props}>
    {/* prettier-ignore */}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.515 9.242h1.97c.653 0 1.182.529 1.182 1.181v10.243c0 .652-.53 1.182-1.182 1.182H4.515c-.653 0-1.182-.53-1.182-1.182V10.423c0-.652.53-1.181 1.182-1.181h1.97V7.957c0-3.19 2.451-5.806 5.515-5.806 3.024 0 5.45 2.548 5.514 5.68l.001.126v1.285zm-1.21 2.363H7.695a1.42 1.42 0 01-.059 0h-1.94v7.88h12.606v-7.88H16.304zm-1.153-2.363V7.957c0-1.917-1.43-3.442-3.152-3.442-1.691 0-3.1 1.47-3.15 3.338l-.001.104v1.285h6.303zm-2.364 6.487a1.575 1.575 0 10-1.576 0v1.393l.002.059a.788.788 0 001.574-.059V15.73z"
    />
  </CreateIconComponent>
);

export default LockIcon;
